module.exports = __webpack_public_path__ + "static/media/YM87_3.f83bec37.jpg";